"use client";

interface ProgressRingProps {
  progress: number;
  phase: string;
}

export function ProgressRing({ progress, phase }: ProgressRingProps) {
  const radius = 34;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <div className="progress-ring" style={{ position: "relative" }}>
      <svg className="progress-ring__svg" viewBox="0 0 80 80">
        <circle
          className="progress-ring__track"
          cx="40"
          cy="40"
          r={radius}
        />
        <circle
          className="progress-ring__bar"
          cx="40"
          cy="40"
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <div
        className="progress-ring__label"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {progress}%
      </div>
      <div className="progress-ring__phase">{phase}</div>
    </div>
  );
}
